import { ComponentInfo } from '../info';

// tslint:disable-next-line:ban-types
export function isInstanceOf(obj: any, type: Function): boolean {
    if (obj instanceof type)
        return true;

    const info = ComponentInfo.getInfo(obj);
    return !!(info && info.originalClass === type);
}


// WEBPACK FOOTER //
// ./node_modules/ts-nameof-loader/main.js!./src/components/utils.ts